/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid } from '@mui/material';
import { MenuWithId } from 'components';
import { useTranslation } from 'react-i18next';
import { DashboardHelpers } from 'utils';

const DeviceDropdown = ({ setSelectedDevice, selectedDevice, devices }) => {
  const { t } = useTranslation();
  const selected = {
    id: selectedDevice?.id,
    name: selectedDevice?.name
      ? selectedDevice.name
      : selectedDevice?.hw_address
        ? DashboardHelpers.trimHWAddress(selectedDevice.hw_address)
        : t('field_average'),
  };

  const selectableDevices = devices.map((device) => ({
    id: device?.id,
    name: device?.name
      ? device.name
      : device?.hw_address
        ? DashboardHelpers.trimHWAddress(device.hw_address)
        : t('field_average'),
  }));

  return (
    <Grid item xs={12} sm={6}>
      <Typography variant="subtitle2" gutterBottom component="div" justifySelf="flex-start">
        {t('device')}
      </Typography>
      <MenuWithId
        placeholder="Device"
        menuItems={
          !selectableDevices || selectableDevices.length === 0 ? [{ id: 0, name: t('none') }] : selectableDevices
        }
        selectedItem={selected.name}
        selectItem={(item) => {
          const device = devices.find((d) => d.id === item.id);
          setSelectedDevice(device);
        }}
        inputProps={{
          maxLength: 24,
        }}
        size="normal"
      />
    </Grid>
  );
};

DeviceDropdown.propTypes = {
  setSelectedDevice: PropTypes.func.isRequired,
  selectedDevice: PropTypes.object,
  devices: PropTypes.array,
};

DeviceDropdown.defaultProps = {
  selectedDevice: undefined,
  devices: [],
};

export default DeviceDropdown;
